import React from "react";

/* ============================================================================
   ToolbarButtons — the icon-only actions that sit above a list.

   One component per action, defined once and imported wherever it is needed.
   A screen never spells out its own Search button: change the colour, the icon
   or the wording here and every list follows.

   Deliberately the same names and the same shapes as the back office
   (InsuranceMgt_Front/src/Common/ToolbarButtons.jsx), so the two codebases
   read the same way.

   An icon is not a label, so every button ships a tooltip AND an accessible
   name — never one without the other.
   ============================================================================ */

const IconButton = ({ variant, icon, title, ariaLabel, ...rest }) => (
  <button
    type="button"
    className={`ui-icon-btn ui-icon-btn--${variant}`}
    title={title}
    aria-label={ariaLabel || title}
    {...rest}
  >
    <i className={`fa ${icon}`} aria-hidden="true"></i>
  </button>
);

/** Applies the filters above a list. The primary action, so it takes navy. */
export const SearchButton = ({ onClick, title = "Search", ariaLabel, ...rest }) => (
  <IconButton
    variant="primary"
    icon="fa-search"
    title={title}
    ariaLabel={ariaLabel || title}
    onClick={onClick}
    {...rest}
  />
);

/** Clears the filters back to their defaults. Amber, not red — it wipes what
 *  you typed but deletes nothing, and red would promise otherwise. */
export const ResetButton = ({ onClick, title = "Reset filters", ariaLabel, ...rest }) => (
  <IconButton
    variant="reset"
    icon="fa-rotate-right"
    title={title}
    ariaLabel={ariaLabel || title}
    onClick={onClick}
    {...rest}
  />
);
